import { render, staticRenderFns } from "./ExtendKFPeriod.vue?vue&type=template&id=ac8ab4ca&scoped=true&"
import script from "./ExtendKFPeriod.vue?vue&type=script&lang=js&"
export * from "./ExtendKFPeriod.vue?vue&type=script&lang=js&"
import style0 from "./ExtendKFPeriod.vue?vue&type=style&index=0&id=ac8ab4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8ab4ca",
  null
  
)

export default component.exports